/* eslint-disable */
import React, { useEffect, useState } from 'react';
import dar_worldMap from '../../../../Assets/images/svg/dar_world_map.svg';
import styles from './revenueByRegion.module.scss';
import dealByRegion from '../../../../Assets/images/svg/dar_by_region.svg';

const RevenueByRegion = () => {
  const initialWidth = window.innerWidth <= 560 ? 300 : 700;
  const [mapDimensions, setMapDimensions] = useState({ width: initialWidth, height: 350 });

  const originalMapWidth = 1000; // Assuming the original SVG width
  const originalMapHeight = 500; // Assuming the original SVG height

  const checkMobileView = () => {
    const screenWidth = window.innerWidth;
    let newWidth;

    if (screenWidth <= 560) {      
      newWidth = screenWidth * 0.68;
    } else if (screenWidth <= 1022) {
      newWidth = Math.min(screenWidth * 0.55, 500);
    } else {
      newWidth = Math.min(screenWidth * 0.40, 700);
    }
    const newHeight = (newWidth / originalMapWidth) * originalMapHeight; // Maintaining aspect ratio
    setMapDimensions({ width: newWidth, height: newHeight });
  };

  const mapBoundaries = {  // Define the bounding box of the map (coordinates for the edges of the map image)
    minLat: -90,  // Bottom
    maxLat: 90,   // Top
    minLon: -180, // Left
    maxLon: 180,  // Right
  };

  const locations = [
    { name: 'New York, USA', coordinates: [-74.006, 30.7128], color: '#211C4A' },
    { name: 'London, UK', coordinates: [-1.1278, 51.5074], color: '#3D32A1' },
    { name: 'Tokyo, Japan', coordinates: [125.6503, 15.6762], color: '#848AF5' }
  ];

  const mapElements = [
    { name: 'Total won', value: '100K' },
    { name: 'Total lost', value: '10K' },
    { name: 'Total WIP', value: '10K' },
  ];

  const getPosition = ([lon, lat]) => {  // Function to convert latitude and longitude to pixel positions on the image
    const { width, height } = mapDimensions;
    const x = ((lon - mapBoundaries.minLon) / (mapBoundaries.maxLon - mapBoundaries.minLon)) * originalMapWidth;
    const y = ((mapBoundaries.maxLat - lat) / (mapBoundaries.maxLat - mapBoundaries.minLat)) * originalMapHeight;
    const scaledX = (x / originalMapWidth) * width; // Scale the positions based on current map dimensions
    const scaledY = (y / originalMapHeight) * height;
    return { x: scaledX, y: scaledY };
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    checkMobileView();
    window.addEventListener('resize', checkMobileView);
    return () => window.removeEventListener('resize', checkMobileView);
  }, []);

  return (
    <div className={styles['revenueByRegion-offerings-Container']} style={{ minHeight: '430px' }}>
      <div>
        <div className={styles['revenueByRegion-header-main']}>
          <img className={styles['revenueByRegion-header-img']} src={dealByRegion} alt="dealByRegion" />
          <div className={styles['revenueByRegion-header-text']}>By region</div>
        </div>
        <div className={styles['revenueByRegion-map-main']}>
          <div className={styles['revenueByRegion-map-secMain']} style={{ width: `${mapDimensions.width}px`, height: `${mapDimensions.height}px` }}>
            <img src={dar_worldMap} alt="World Map" style={{ width: `${mapDimensions.width}px`, height: `${mapDimensions.height}px` }} />
            {locations.map(({ name, coordinates, color }) => {
              const { x, y } = getPosition(coordinates);
              return (
                <div key={name} className={styles['revenueByRegion-map-marking-main']} style={{ left: `${x}px`,top: `${y}px`,transform: 'translate(-50%, -50%)',}}>
                  <div className={styles['revenueByRegion-map-marking-secMain']} style={{backgroundColor: color, }}>$78k
                  <div className={styles['revenueByRegion-map-marking-arrow']} style={{borderTop: `10px solid ${color}`}} />
                  </div>
                  <div className={styles['revenueByRegion-map-marking-circle']} style={{border: `2px solid ${color}`, }}>
                    <div className={styles['revenueByRegion-map-marking-innerCircle']} style={{backgroundColor: color,}} />
                  </div>
                </div>
              );
            })}
          </div>
          <div className={styles['revenueByRegion-section2-main']}>
            {mapElements.map((item) => (
              <div className={styles['revenueByRegion-section2-map']} key={item.name}>
                <div className={styles['revenueByRegion-section2-dot']}/>
                <div>
                  <div className={styles['revenueByRegion-section2-name']}>{item.name}</div>
                  <div className={styles['revenueByRegion-section2-value']}>{item.value}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RevenueByRegion;
